import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=ccdda6a4&scoped=true"
import script from "./digital.vue?vue&type=script&lang=js"
export * from "./digital.vue?vue&type=script&lang=js"
import style0 from "./digital.vue?vue&type=style&index=0&id=ccdda6a4&prod&lang=stylus"
import style1 from "./digital.vue?vue&type=style&index=1&id=ccdda6a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccdda6a4",
  null
  
)

export default component.exports